import React,{useState, useEffect} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import Room from './Room';
import MoveButton from './MoveButton';
import OKButton from './OKButton';
import Bridge from './Bridge';
import Called from './Called';
import {Tools} from './Tools';
import {Styles} from './Styles';
import {Inc,EventParam,Play} from './Inc';
import Ajax from './Ajax';

interface Props {
    uid:string,
    move(str:string):void,
    save(id:string):void,
    die(play:Play):void,
}

let tid:NodeJS.Timeout;
let nextRoom:string = "";
let nextDir:"f"|"r"|"n" = "n";
let sameFloor = 1;
let lockMove:boolean = false;

const Board = (props:Props)=> {
    Ajax.setUid(props.uid);
    const classes = Styles.base();
    const defParam:EventParam = {
        bottles: [],
        event: Inc.defaultEvent(),
        selected: -1,
        called: 0,
        message: "",
        talks: [],
        talk_id: 0,
    }
    const [states,setStates] = useState({
        play: Inc.defaultPlay(),
        param: defParam,
        isModal: false,
        isBridge: false,
        showBottom: true,
        modalPage: "",
    })
    const moveUp = ()=>{
        if( !lockMove ){
            lockMove = true;
            sameFloor=1;
            move("f");
        }
    }
    const moveNext = ()=>{
        if( !lockMove ){
            lockMove = true;
            sameFloor++;
            move("r");
        }
    }
    const move = (dir:"f"|"r")=>{
        nextDir = dir;
        if( dir==="f" ){
            nextRoom = String(states.play.floor_num+1)+"F";
        } else {
            nextRoom = Tools.roomName(states.play.floor_num,states.play.room_num+1);
        }

        setStates({...states,isBridge:true,showBottom:false});
        loadEvent((res:any)=>{
            tid = setTimeout( ()=>{
                lockMove = false;
                setStates({...states,play:res.play,param:res.param,isBridge:false,isModal:true,modalPage:"room"});
            },1000);
        });
    }
    const loadEvent = (func:any)=>{
        Ajax.send("event/get",{play_id:states.play.id,dir:nextDir},(res:any)=>{
            //console.log(res);
            if( res.ok ){
                func(res);
            }
        })
    }
    const start = ()=>{
        //setStates({...states,play:{...states.play,turn:1},"isModal":true,showBottom:false});
        loadEvent((res:any)=>{
            setStates({...states,play:res.play,param:res.param,showBottom:false,isModal:true,modalPage:"room"});
        });
    }
    const closeModal = (play:Play)=>{
        if( play.water===0 || play.magenta===100 || play.cyan===100 || play.yellow===100 ){
            props.die(play);
        } else if( states.param.called>0 ){
            setStates({...states,modalPage:"called",param:{...states.param,called:0}});
        } else {
            setStates({...states,play:play,isModal:false,modalPage:"",showBottom:true});
        }
    };

    useEffect( ()=>{
        nextDir = "n";
        sameFloor = 1;
        Ajax.send("play/get",{},(res:any)=>{
            //console.log("play/get",res);
            if( res.ok ){
                setStates({...states,play:res.play});
            }
        });
        return ()=>{
            clearTimeout(tid);
        }
    },[]);

    return (
		<div id="board" className={classes.mainRoot}>
            {states.play.turn===0 ? (
            <React.Fragment>
                <div className={classes.boardPlate}>
                    目覚め
                </div>
                <div className={classes.story}>
                    知らない部屋で目が覚めた<br/>
                    隣には誰かの寝ていた形跡がある<br/>
                    忘れる前に、行かなくては<br/>
                </div>
            </React.Fragment>
            ):(
            <React.Fragment>
                <div className={classes.boardPlate}>
                    {Tools.roomName(states.play.floor_num,states.play.room_num)}<span style={{fontSize:"75%"}}>号室</span>
                </div>
                <div className={classes.story}>
                    この部屋はきみの世界から消えかけている<br/>
                    きみは出ていかなくてはならない<br/>
                    {states.play.lover_end==="2" &&
                    <span>これはきみと{states.play.lover_name}の旅だ</span>
                    }
                </div>
                
            </React.Fragment>
            )}
            <Fade in={states.showBottom} timeout={{enter:500,exit:500}}>
                <AppBar position="fixed" color="primary" style={{position:"fixed",bottom:"0",top:"auto",lineHeight:"1em"}}>
                    <Toolbar style={{padding:"0"}}>
                    {states.play.turn===0 &&
                        <OKButton ok={start}/>
                    }
                    {states.play.turn>0 &&
                        <MoveButton up={moveUp} next={moveNext} isLock={lockMove} isNext={sameFloor<8}/>
                    }
                    </Toolbar>
                </AppBar>
            </Fade>


            <Modal
				aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                disableBackdropClick={true}
				open={states.isModal}
				onClose={closeModal}
			>
				<div style={Tools.getModalStyle()} className={classes.modal}>
                    {states.modalPage==="room" &&
                    <Room uid={props.uid} play={states.play} param={states.param} close={closeModal}/>
                    }
                    {states.modalPage==="called" &&
                    <Called uid={props.uid} play={states.play} close={closeModal}/>
                    }
	    		</div>
			</Modal>
            <Bridge show={states.isBridge} dir={nextDir} nextRoom={nextRoom}/>
		</div>
	);
}

export default Board;
